import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Close as CloseIcon, EllipsisVertical as EllipsisVerticalIcon } from "@air/next-icons";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { IconButton } from "@air/primitive-icon-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import pluralize from "pluralize";
import { memo } from "react";
import { SELECTION_ACTION_BAR_ID } from "~/constants/selectionActionBar";
import { SELECTION_ACTION_BAR, SELECTION_ACTION_BAR_CLEAR_BTN, SELECTION_ACTION_BAR_ITEMS_SELECTED } from "~/constants/testIDs";
/**
 * Displays as a sticky panel at the bottom of the content area
 * Will show the first 4 menu options and move the remaining into an ellipsis menu
 */ export const SelectionActionBarComponent = /*#__PURE__*/ memo((param)=>{
    let { menuOptions, numberOfSelectedItems, onClearAll, itemLabel = "", PrefixBarButtons = [], SuffixBarButtons = [] } = param;
    const { isAboveSmallScreen } = useBreakpointsContext();
    const itemPluralText = pluralize(itemLabel, numberOfSelectedItems);
    const itemCountText = !isAboveSmallScreen ? " selected" : " ".concat(itemPluralText, " selected");
    return /*#__PURE__*/ _jsxs("div", {
        className: "z-portal flex w-full items-center justify-between rounded-8 bg-grey-12/80 p-4 text-grey-1 backdrop-blur-[18px] duration-300 animate-in fade-in slide-in-from-bottom-4",
        "data-testid": SELECTION_ACTION_BAR,
        id: SELECTION_ACTION_BAR_ID,
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                className: "mr-3 text-grey-1 hover:bg-grey-10 active:bg-grey-9 ui2:rounded-4",
                color: "grey",
                "data-testid": SELECTION_ACTION_BAR_CLEAR_BTN,
                icon: CloseIcon,
                label: "Clear all",
                onClick: onClearAll,
                size: "small"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center",
                "data-testid": SELECTION_ACTION_BAR_ITEMS_SELECTED,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "mr-2 text-12 text-grey-1",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            children: numberOfSelectedItems
                        }),
                        itemCountText
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex grow items-center justify-end gap-2",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex gap-2",
                        children: PrefixBarButtons === null || PrefixBarButtons === void 0 ? void 0 : PrefixBarButtons.map((button, index)=>/*#__PURE__*/ _jsx("div", {
                                children: button
                            }, index))
                    }),
                    menuOptions.length > 0 && /*#__PURE__*/ _jsx(DropdownMenu, {
                        sideOffset: 16,
                        className: "w-[240px]",
                        trigger: /*#__PURE__*/ _jsx(IconButton, {
                            appearance: "ghost",
                            className: "text-grey-1 hover:bg-grey-10 active:bg-grey-9 ui2:rounded-4",
                            color: "grey",
                            "data-testid": "SELECTION_ACTION_BAR_MORE_ACTIONS",
                            label: "More actions",
                            size: "small",
                            children: /*#__PURE__*/ _jsx(EllipsisVerticalIcon, {
                                className: "size-4"
                            })
                        }),
                        children: renderDropdownItems({
                            options: menuOptions
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex gap-2",
                        children: SuffixBarButtons === null || SuffixBarButtons === void 0 ? void 0 : SuffixBarButtons.map((button, index)=>/*#__PURE__*/ _jsx("div", {
                                children: button
                            }, index))
                    })
                ]
            })
        ]
    });
});
SelectionActionBarComponent.displayName = "SelectionActionBarComponent";
